/*
 * vip-konf.js – VIP Sale 2026 (Agent C, 20.10.2026)
 *
 * 1. Konfiguratoren: unter der Preiszeile der Zusammenfassung eine Noir/Gold-Zeile mit dem VIP-Rabatt.
 *      Sale (early|vipday|day2|day3): "+ zusätzlich X % VIP-Rabatt im Warenkorb (ca. −Y €)"
 *        X = VIP.tierFor(Warenkorbwert vor Rabatt + Setpreis).pct, Y = Setpreis × X %
 *      pre:  "Ab 25.10. zusätzlich bis zu 33 % VIP-Rabatt" (Höchstwert aus VIP_CONFIG)
 *      post: keine Zeile
 *    Ziele (Preise der Konfiguratoren werden NICHT verändert, nur gelesen):
 *      - "Dein Set steht" (assets/mh-konf-suite.js): WPC-Dielen, Terrassenplatten, Sichtschutzzaun
 *        (ENZO/ModuLine/MARIO, mh-zaun-konfigurator), Doppelstabmattenzaun
 *      - Pergola "Deine Zusammenstellung" (snippets/mh-pergola-config.liquid, Zeile "Gesamt")
 *      - alter Sichtschutz-Konfigurator (snippets/sichtschutz-konfigurator.liquid, .mhc__final-row)
 * 2. Pergola-PDP: deren eigener Preisblock (#mhpg-price) bekommt denselben Chip
 *    "Zusätzlich VIP-Rabatt sichern" wie snippets/vip-pdp-savings.liquid (Theme-Preisblock ist dort ausgeblendet).
 *
 * 21.10.: Set, das schon im Warenkorb liegt, wird nicht doppelt gezählt (siehe basisWithoutSet).
 * Klick auf Zeile/Chip öffnet das Staffel-Modal (data-vip-open-tiers, delegiert in vip-banner.js).
 * Liest window.VIP (vip-core.js) nur. Eingebunden über snippets/mh-konf-aktion.liquid (alle Seiten).
 */
(function () {
  'use strict';
  if (window.__vipKonf) return;
  window.__vipKonf = true;

  var TARGETS = [
    { box: '.mhks-set__in', after: '.mhks-set__sv, .mhks-set__h', price: '.mhks-set__pr b' },
    { box: '.mhpg-zs__body', after: '.mhpg-sum__total', price: '#mhpg-sum-total' },
    { box: '.mhc__price', after: '.mhc__final-row', price: '[data-final]' }
  ];
  var LINE = 'vip-konf-line';

  var CSS =
    '.vip-konf-line{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:8px 0 2px;padding:8px 12px;border-radius:10px;' +
      'background:#141110;border:1px solid #cfac3a;color:#cfac3a;' +
      'font-family:var(--font-body-family,inherit),sans-serif;font-size:12.5px;font-weight:600;line-height:1.4;text-align:left;cursor:pointer;letter-spacing:normal;text-transform:none}' +
    '.vip-konf-line b{font-weight:800;color:#cfac3a}.vip-konf-line__y{white-space:nowrap}' +
    '.vip-konf-line__i{flex:none;display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:50%;border:1px solid #cfac3a;font-size:11px;font-weight:700;font-style:normal;line-height:1}' +
    '.vip-konf-line:focus-visible{outline:2px solid #cfac3a;outline-offset:2px}' +
    '.mhpg-zs__body .vip-konf-line{margin:8px 0 6px}' +
    '#mhpg-price .f-price__sale{flex-wrap:wrap}' +
    'button.vip-pdp-chip{-webkit-appearance:none;appearance:none;display:inline-flex!important;align-items:center;gap:6px;flex:0 0 auto;margin:0!important;min-height:0!important;height:auto!important;width:auto!important;' +
      'background:#141110!important;color:#cfac3a!important;border:1px solid #cfac3a!important;box-shadow:none!important;' +
      'padding:7px 14px!important;line-height:1!important;font-family:inherit!important;font-weight:700!important;font-size:14px!important;white-space:nowrap;letter-spacing:normal!important;text-transform:none!important;cursor:pointer;border-radius:9999px!important}' +
    'button.vip-pdp-chip .vip-pdp-chip__i{width:15px;height:15px;flex:0 0 auto}' +
    '@media (max-width:749px){button.vip-pdp-chip{font-size:13px!important;padding:6px 11px!important}}';
  try { var st = document.createElement('style'); st.id = 'vip-konf-css'; st.textContent = CSS; document.head.appendChild(st); } catch (e) {}

  function cents(t) {
    var s = String(t || '').replace(/[^\d,.-]/g, '');
    if (!s) return 0;
    if (s.indexOf(',') > -1) s = s.replace(/\./g, '').replace(',', '.');
    else if (/\.\d{3}$/.test(s)) s = s.replace(/\./g, '');
    var v = parseFloat(s);
    return isFinite(v) ? Math.round(v * 100) : 0;
  }
  function maxPct() {
    var m = 0, ph = (window.VIP_CONFIG && window.VIP_CONFIG.phases) || [];
    ph.forEach(function (p) { (p.tiers || []).forEach(function (t) { if (+t.pct > m) m = +t.pct; }); });
    return m || 33;
  }
  function fmt(c) {
    try { return window.VIP.formatEUR(c); } catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  /* Markus 21.10.: Doppelzählung vermeiden. Liegt das aktuell konfigurierte Set schon im Warenkorb, darf es nicht zusätzlich zum
     Warenkorbwert gezählt werden. Die Konfiguratoren nutzen unterschiedliche Kennungen (_mh_konfig_id, _set, Warenkorb-Attribute),
     daher merkt sich dieses Script beim erfolgreichen /cart/add (fetch-Hook) die hinzugefügten Varianten + Mengen zusammen mit dem
     Setpreis (sessionStorage je Seite). Solange der Setpreis gleich bleibt, werden diese Zeilen aus der Warenkorb-Basis herausgerechnet
     (höchstens die gemerkte Menge, nur wenn noch im Warenkorb) → Stufe = Warenkorb ohne Set + Set = tatsächlicher Warenkorb.
     Ändert der Kunde die Konfiguration (anderer Setpreis), zählt das bereits hinzugefügte Set normal mit (zweites Set käme dazu). */
  var ADDED_KEY = 'vip_konf_added:' + location.pathname;
  function loadAdded() { try { return JSON.parse(sessionStorage.getItem(ADDED_KEY) || 'null'); } catch (e) { return null; } }
  function saveAdded(o) { try { sessionStorage.setItem(ADDED_KEY, JSON.stringify(o)); } catch (e) {} }
  function currentSetCents() {
    var c = 0;
    TARGETS.some(function (tg) {
      var box = document.querySelector(tg.box), pe = box && box.querySelector(tg.price);
      if (pe) c = cents(pe.textContent);
      return !!c;
    });
    return c;
  }
  function parseAddBody(body) {
    var out = [];
    if (!body) return out;
    try {
      if (typeof body === 'string') {
        var t = body.trim();
        if (t.charAt(0) === '{') {
          var o = JSON.parse(t);
          (o.items || (o.id ? [o] : [])).forEach(function (it) { out.push({ id: +it.id, q: +(it.quantity || 1) }); });
        } else {
          var p = new URLSearchParams(t);
          if (p.get('id')) out.push({ id: +p.get('id'), q: +(p.get('quantity') || 1) });
        }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        if (body.get('id')) out.push({ id: +body.get('id'), q: +(body.get('quantity') || 1) });
      }
    } catch (e) {}
    return out.filter(function (x) { return x.id && x.q > 0; });
  }
  function recordAdd(items) {
    var sc = currentSetCents();
    if (!sc || !items.length) return;
    var prev = loadAdded();
    var rec = (prev && prev.set === sc) ? prev : { set: sc, lines: {} };
    items.forEach(function (x) { rec.lines[x.id] = (rec.lines[x.id] || 0) + x.q; });
    saveAdded(rec);
  }
  (function hookFetch() {
    if (!window.fetch || window.fetch.__vipKonf) return;
    var orig = window.fetch;
    var wrapped = function (input, init) {
      var items = null;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body && document.querySelector(TARGETS.map(function (t) { return t.box; }).join(','))) {
          items = parseAddBody(init.body);
        }
      } catch (e) { items = null; }
      var res = orig.apply(this, arguments);
      if (items && items.length) {
        try { res.then(function (r) { if (r && r.ok) { recordAdd(items); soon(); } }).catch(function () {}); } catch (e) {}
      }
      return res;
    };
    wrapped.__vipKonf = true;
    window.fetch = wrapped;
  })();
  function basisWithoutSet(cart, setCents) {
    var V = window.VIP, b = V.cartBasisCents(cart) || 0;
    var rec = loadAdded();
    if (!rec || rec.set !== setCents || !cart || !cart.items) return b;
    var left = {};
    Object.keys(rec.lines).forEach(function (k) { left[k] = rec.lines[k]; });
    var sub = 0;
    cart.items.forEach(function (it) {
      if (V.isGiftLine && V.isGiftLine(it)) return;
      var q = left[it.variant_id] || 0;
      if (!q || !it.quantity) return;
      var take = Math.min(q, it.quantity);
      var line = (typeof it.original_line_price === 'number') ? it.original_line_price : (it.original_price || it.price || 0) * it.quantity;
      sub += Math.round(line / it.quantity * take);
      left[it.variant_id] = q - take;
    });
    return Math.max(0, b - sub);
  }

  function textFor(ph, setCents) {
    if (!ph || ph.key === 'post') return '';
    if (ph.key === 'pre' || !ph.active) return 'Ab 25.10. zusätzlich bis zu <b>' + maxPct() + ' %</b> VIP-Rabatt';
    if (!setCents) return '';
    var basis = 0;
    try { basis = basisWithoutSet(window.VIP.cart, setCents); } catch (e) { basis = 0; }
    var t = null;
    try { t = window.VIP.tierFor(basis + setCents); } catch (e) { t = null; }
    if (!t || !t.pct) return '';
    var y = Math.round(setCents * t.pct / 100);
    return '+ zusätzlich <b>' + t.pct + ' %</b> VIP-Rabatt im Warenkorb <span class="vip-konf-line__y">(ca. −' + fmt(y) + ')</span>';
  }

  function chipHtml() {
    return '<svg class="vip-pdp-chip__i" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5z"/></svg><span>Zusätzlich VIP-Rabatt sichern</span>';
  }

  var busy = false;
  function run() {
    if (!window.VIP || busy) return;
    busy = true;
    try {
      var ph = window.VIP.phase();
      TARGETS.forEach(function (tg) {
        [].forEach.call(document.querySelectorAll(tg.box), function (box) {
          var pe = box.querySelector(tg.price);
          var html = textFor(ph, pe ? cents(pe.textContent) : 0);
          var el = box.querySelector('.' + LINE);
          if (!html) { if (el) el.parentNode.removeChild(el); return; }
          var after = null;
          tg.after.split(',').some(function (sel) { after = box.querySelector(sel.trim()); return !!after; });
          if (!el) {
            el = document.createElement('div');
            el.className = LINE;
            el.setAttribute('data-vip-open-tiers', '');
            el.setAttribute('role', 'button');
            el.setAttribute('tabindex', '0');
            el.setAttribute('aria-haspopup', 'dialog');
            el.setAttribute('aria-controls', 'vip-tier-modal');
            el.title = 'Alle VIP-Rabattstufen anzeigen';
          }
          if (after) { if (after.nextSibling !== el) after.parentNode.insertBefore(el, after.nextSibling); }
          else if (el.parentNode !== box) box.appendChild(el);
          var inner = '<span class="vip-konf-line__t">' + html + '</span><span class="vip-konf-line__i" aria-hidden="true">i</span>';
          if (el.__h !== inner) { el.innerHTML = inner; el.__h = inner; }
        });
      });
      /* Pergola-Preisblock: Chip wie auf allen anderen PDPs */
      [].forEach.call(document.querySelectorAll('#mhpg-price .f-price__sale'), function (sale) {
        var chip = sale.querySelector('.vip-pdp-chip');
        var on = ph && ph.key !== 'post';
        if (!on) { if (chip) chip.parentNode.removeChild(chip); return; }
        if (!chip) {
          chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'vip-pdp-chip';
          chip.setAttribute('data-vip-open-tiers', '');
          chip.setAttribute('aria-haspopup', 'dialog');
          chip.setAttribute('aria-controls', 'vip-tier-modal');
          chip.innerHTML = chipHtml();
          sale.appendChild(chip);
        }
      });
    } catch (e) { /* still */ }
    busy = false;
  }

  var tm = null;
  function soon() { if (tm) return; tm = setTimeout(function () { tm = null; run(); }, 150); }

  /* Tastatur: Enter/Leertaste auf der Zeile wie Klick */
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.classList && e.target.classList.contains(LINE)) {
      e.preventDefault(); e.target.click();
    }
  });

  function init() {
    if (!window.VIP) { setTimeout(init, 300); return; }
    window.VIP.onPhase(soon);
    window.VIP.onCart(soon);
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var n = muts[i].target; n = n && n.nodeType === 1 ? n : (n && n.parentElement);
          if (n && n.closest && (n.closest('.' + LINE) || n.closest('.vip-pdp-chip'))) continue;
          soon(); return;
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    run();
    setInterval(run, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
